<template>
  <div class="section-statistics__opens-hourly-bar">
    <h4 class="cm-title">
      Открытия по часам
    </h4>
    <div :class="[
      'section-statistics__row',
      {'section-statistics__row--long-table-mode': longTablePart}
    ]">
      <CmStateCard
        :isLoading="isLoading"
        :isError="isError"
        :isEmpty="!value || (value && !value.length)"
        class="cm-state-card--grouped-bar"
      >
        <CmBar
          mainKey="date"
          :labels="labels"
          :value="value"
          :colors="colors"
          :paddingInner="0.10"
          :isHourly="true"
          @get-formed-data="getHourlyData"
        />
      </CmStateCard>

      <HourlyTablePart
        :isLoading="isLoading"
        :isError="isError"
        :value="tableData"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getPercent } from "@/utils/general";

import CmStateCard from '@/components/library/statistics/cards/CmStateCard.vue';
import CmBar from "@/components/library/statistics/elements/CmGroupedBar.vue";
import HourlyTablePart from "./HourlyTablePart.vue";

export default {
  components: {
    CmStateCard,
    CmBar,
    HourlyTablePart
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      colors: ["#FFDA83"],
      labels: {
        opened: "Уникальных открыто"
      },
      tableData: []
    }
  },

  watch: {
    value (next) {
      if (!next.length) {
        this.tableData.length = 0;
      }
    }
  },

  computed: {
    ...mapState({
      longTablePart: state => state.stat.longTablePart
    }),
  },

  methods: {
    getHourlyData(val) {
      const totalNum = val.reduce(
        (total, d) => total + d.opened, 0
      );

      this.tableData = val.sort((a, b) => +a.date - +b.date).map(i => {
        const { date, opened } = i;
        return {
          hours: `${date}:00-${date}:59`,
          opened,
          openedPercent: getPercent(totalNum, opened)
        }
      });
    }
  }
}
</script>


<style lang="scss">
.section-statistics__opens-hourly-bar {
  width: 100%;
  h2 {
    margin-bottom: 20px;
  }
}
</style>
